/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { getPetPlans } from 'services/api/petApi';
import { TPlanList } from 'typings';
import { TPetPlanState } from 'typings/petTypes';

export const fetchPetPlans = createAsyncThunk(
  'spaces/fetchPetPlans',
  async (payload: string, thunkAPI) => {
    try {
      const response = await getPetPlans(payload);
      return response.data;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchPetPlans',
          error_type: 'api_error'
        },
        extra: {
          payload
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TPetPlanState = {
  petPlanList: [],
  isLoading: false
};

export const allPlanSlice = createSlice({
  name: 'allPlans',
  initialState: initialPlanState,
  reducers: {
    clearPetPlansData: (state) => {
      state.petPlanList = [];
    },
    updatePetPlansData: (state, action) => {
      state.petPlanList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPetPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.petPlanList = action.payload as TPlanList[];
      })
      .addCase(fetchPetPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPetPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearPetPlansData, updatePetPlansData } = allPlanSlice.actions;

export default allPlanSlice.reducer;
